export const getNumFromStr = str => parseInt(str.match(/\d+/)[0], 10);

export const getStyle = (element, css) => getComputedStyle(element)[css];


// WEBPACK FOOTER //
// ./src/redux/utils/index.js